import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import Rating from "../../../../components/Rating";

const ShowRatingAndReview = ({
  orderReviewFromOtherUserValue,
  orderReviewFromThisUserValue,
}) => {
  const [orderReviewFromOtherUser, setOrderReviewFromOtherUser] = useState({});
  const [orderReviewFromThisUser, setOrderReviewFromThisUser] = useState({});
  const orderData = useSelector((state) => state.order);

  useEffect(() => {
    setOrderReviewFromOtherUser(orderReviewFromOtherUserValue[0]);
  }, [orderReviewFromOtherUserValue]);

  useEffect(() => {
    setOrderReviewFromThisUser(orderReviewFromThisUserValue[0]);
  }, [orderReviewFromThisUserValue]);

  return (
    <section id="review-section">
      <div className="container theme-section">
        <div className="row user-loads-details-area">
          {orderData.otherUserGiveReview === true ? (
            <div className="col-lg-6">
              <h1 className="section-tittle text-center">
                {orderReviewFromOtherUser?.from_user_obj?.username}'S REVIEW
              </h1>
              <div className="row">
                <div className="col-xl-6 col-lg-6 mb-3">
                  <div className="user-image-rating">
                    <div className="reivew-user-img">
                      <img
                        src={
                          orderReviewFromOtherUser?.from_user_obj
                            ?.profile_picture_url
                        }
                        alt=""
                      />
                    </div>
                    <div className="user-name-rate">
                      <p>{orderReviewFromOtherUser?.from_user_obj?.username}</p>
                      <div className="rating-star">
                        {!["", null, undefined].includes(
                          orderReviewFromOtherUser?.review_rating
                        ) && (
                          <Rating
                            rating={orderReviewFromOtherUser?.review_rating}
                          />
                        )}
                      </div>
                      <span>{orderReviewFromOtherUser?.created_at}</span>
                    </div>
                  </div>
                </div>
                <div
                  className="col-xl-6 col-lg-6 the-review-text"
                  show-more="false"
                >
                  <p>{orderReviewFromOtherUser?.review_text}</p>
                </div>
              </div>
            </div>
          ) : (
            <></>
          )}

          {orderData.thisUserGiveReview === true ? (
            <div className="col-lg-6">
              <h1 className="section-tittle text-center">YOUR REVIEW</h1>
              <div className="row">
                <div className="col-xl-6 col-lg-6 mb-3">
                  <div className="user-image-rating">
                    <div className="reivew-user-img">
                      <img
                        src={
                          orderReviewFromThisUser?.from_user_obj
                            ?.profile_picture_url
                        }
                        alt=""
                      />
                    </div>
                    <div className="user-name-rate">
                      <p>{orderReviewFromThisUser?.from_user_obj?.username}</p>
                      <div className="rating-star">
                        {!["", null, undefined].includes(
                          orderReviewFromThisUser?.review_rating
                        ) && (
                          <Rating
                            rating={orderReviewFromThisUser?.review_rating}
                          />
                        )}
                      </div>
                      <span>{orderReviewFromThisUser?.created_at}</span>
                    </div>
                  </div>
                </div>
                <div
                  className="col-xl-6 col-lg-6 the-review-text"
                  show-more="false"
                >
                  <p>{orderReviewFromThisUser?.review_text}</p>
                </div>
              </div>
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
    </section>
  );
};

export default React.memo(ShowRatingAndReview);
